import { useParams } from "react-router";
import { useBatchFix } from "./hooks/useBatchFix";
import { FailureSummary } from "./FailureSummary";
import { HeaderTreeEditor } from "./HeaderTreeEditor";
import { ActionPane } from "./ActionPane";
import { previewRetry } from "./api/batch-fix";
import { useState } from "react";

export function BatchFixPage() {
  const { batchId } = useParams();
  const { state, loading } = useBatchFix(batchId!);
  const [previewResult, setPreviewResult] = useState<{
    ok: boolean;
    profileId?: string;
  } | null>(null);
  const [editedHeader, setEditedHeader] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  if (success) {
    return <div>Batch advanced — returning to queue.</div>;
  }

  if (loading || !state) {
    return <div>Loading...</div>;
  }

  return (
    <div className="batch-fix-station">
      <header className="station-header">
        Batch needs header review &middot; {batchId}
      </header>
      <div className="pane-grid">
        <FailureSummary
          reason={state.headerRejectedReason}
          history={state.rawHeaderHistory}
        />
        <HeaderTreeEditor
          raw={state.rawHeaderBlob}
          format={state.rawHeaderFormat}
          onPreview={async (raw, fmt) => {
            setEditedHeader(raw);
            const res = await previewRetry(batchId!, {
              rawHeader: raw,
              format: fmt,
            });
            setPreviewResult(res);
            return res;
          }}
        />
        <ActionPane
          batchId={batchId!}
          candidateForms={state.candidateForms}
          role="supervisor"
          onAfterAction={() => {
            setSuccess(true);
          }}
          previewOk={previewResult?.ok ?? false}
          editedHeader={editedHeader ?? state.rawHeaderBlob}
          headerFormat={state.rawHeaderFormat}
        />
      </div>
    </div>
  );
}
